export default __webpack_public_path__ + "static/media/printing.08f87708.svg";